// @ts-nocheck
import { ThemeEvents } from '@theme/events';
import { morph, MORPH_OPTIONS } from '@theme/morph';
import { Component } from '@theme/component';

class PdpRestockNotify extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBlock);
    this.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBlock);
    this.removeEventListener('submit', this.onSubmit);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateBlock = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector('pdp-restock-notify');
    if (!newBlock) return;

    // Root attributes (hidden / --hidden class / variant data) must sync —
    // default morph is childrenOnly and would leave visibility stuck.
    morph(this, newBlock, { ...MORPH_OPTIONS, childrenOnly: false });
  };

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  onSubmit = async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target?.closest?.('[data-restock-form]');
    if (!form || !form.hasAttribute('data-restock-form')) return;

    event.preventDefault();

    const endpoint = form.dataset.apiEndpoint || '';
    const submitBtn = form.querySelector('[type="submit"]');
    const emailInput = form.querySelector('[name="email"]');
    const email = emailInput?.value?.trim() || '';
    const alertEl = this.querySelector('[data-restock-alert]');
    const formView = this.querySelector('[data-restock-form-view]');
    const successView = this.querySelector('[data-restock-success-view]');
    const successEmailEl = this.querySelector('[data-restock-success-email]');

    if (!email || !this.isValidEmail(email)) {
      this.showMessage(
        alertEl,
        form.dataset.emailInvalidMessage || form.dataset.emailRequiredMessage || 'Please enter a valid email address.'
      );
      emailInput?.focus();
      return;
    }

    if (!endpoint) {
      this.showMessage(alertEl, form.dataset.endpointMissingMessage || 'API endpoint is not configured yet.');
      return;
    }

    if (submitBtn) submitBtn.disabled = true;
    this.showMessage(alertEl, '', true);

    const payload = {
      email,
      product_id: this.dataset.productId || '',
      product_title: this.dataset.productTitle || '',
      variant_id: this.dataset.variantId || '',
      variant_title: this.dataset.variantTitle || '',
      product_url: this.dataset.productUrl || ''
    };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-api-key': 'uoirweuorudlfjlsd'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Request failed');

      if (successEmailEl) successEmailEl.textContent = email;
      if (formView) formView.hidden = true;
      if (successView) {
        successView.hidden = false;
        successView.focus?.();
      }
      this.showMessage(alertEl, '', true);
    } catch (error) {
      this.showMessage(alertEl, form.dataset.errorMessage || 'Something went wrong. Please try again later.');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  };

  showMessage(alertEl, text, clearOnly = false) {
    if (!alertEl) return;

    const textEl = alertEl.querySelector('[data-restock-alert-text]');

    if (clearOnly || !text) {
      alertEl.hidden = true;
      if (textEl) textEl.textContent = '';
      return;
    }

    alertEl.hidden = false;
    if (textEl) {
      textEl.textContent = text;
    } else {
      alertEl.textContent = text;
    }
  }
}

if (!customElements.get('pdp-restock-notify')) {
  customElements.define('pdp-restock-notify', PdpRestockNotify);
}
